const marketingPage = function () {
    	const subscribeArticleDialog = new Dialog4i();
 	const pageLinks = [].slice.call(document.querySelectorAll("a"));
	let popupOpened = false;
 	let subscribeBtn, emailInput, infoText, submitLoading;
 	
     	const init = () =>{
        	SubscribeDialog.Init();
        	window.onscroll = scrollToOpenDialog;
    	};
    	
    	const displaySubscribePopup = () => {
		if (!popupOpened) {
			const docFooter = document.getElementsByTagName('footer')[0];
            		const footerDims = docFooter.getBoundingClientRect();
            	 	const topDiff = (window.scrollY + window.innerHeight) - (footerDims.top + document.body.scrollTop);

            		if ((topDiff > 0 && (topDiff / window.innerHeight) > 1) || window.scrollY + window.innerHeight == document.body.offsetHeight)
                		return true;
        	}
        	return false;
    	};
    	
    	const scrollToOpenDialog = () => {
        	if (displaySubscribePopup()) {
            		popupOpened = true;
            		if (!document.getElementById('popUpDialog')) subscribeArticleDialog.Open();
        	}
    	};
    	
    	let SubscribeDialog = (function(){
    		const init = () => {
			const dialogContent = getContent();
			
			subscribeArticleDialog.Init({
				triggerElements: [], 
				dialogClass: "mediumDialog", 
				title: "Never miss future articles again!", 
				content: dialogContent, 
				onOpen: open,
				onClose: setFocus
			});
    		};
    		const open = () =>{
    			subscribeBtn = document.getElementById('submitEmailDialogButton');
			emailInput = document.getElementById("Email") ? document.getElementById("Email") : "";
			infoText = document.querySelector('.infoText');
			submitLoading = document.getElementById('popUpDialog').querySelector(".loadingIcon");
			
    			subscribeBtn.addEventListener('click', subscribeRequest);
    		};
    		const getContent = () =>{
    			let regexPattern = "^([\\w&+'.-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-zA-Z\\-]{2,24}(?:\\.[a-zA-Z\\-]{2})?)$";
    			let htmlContent = 
				'<div id="infoTextEmail" class="infoText textLeft"></div>' +
				'<div class="subscribeForm">' +
					'<div class="textCenter">' +
						'<svg class="textBlue hideOnSmall layoutCenter" height="45px" width="60px"><use xlink:href="#svgIcon-email"></use> </svg>' +
						'<p class="text16 textSemiBold textBlue marginBtm10">Subscribe via email to be the first to learn when a new article is published.</p>' +
					'</div>' +
					'<div class="displayFlex flexNoWrap flexAlignItemsFlexEnd form2018">' +
						'<div class="form-group">' +
							'<label for="Email">Email (username@example.com)</label>' +
							'<input type="text" class="formTxt emailTextInput input-control" id="Email" autocomplete="email" data-val="true" data-val-regex="Email" data-val-required="Email" data-val-regex-pattern="' + regexPattern + '" />' +
						'</div>' +
						'<div class="marginBtm20 submitBtnWrapper">' +
							'<button type="button" id="submitEmailDialogButton" class="submitEmailBtn button-sm bkgdBlue text16">Sign Up</button>' +
						'</div>' +
					'</div>' +
					'<div class="loadingIcon hide" role="status">' +
						'<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Submitting form, please wait">' +
				  			'<div class="bounce1"></div>' +
				  			'<div class="bounce2"></div>' +
				  			'<div class="bounce3"></div>' +
						'</div>' +
					'</div>' +
				'</div>';
    				
    			return htmlContent;
    		};
    		const disableBtn = () =>{
	    		subscribeBtn.classList.add('disabledBtn');
	    		subscribeBtn.classList.remove('whiteLink');
	    		subscribeBtn.disabled = true;
	    	};
	    	const subscribeRequest = e =>{
			e.preventDefault();
	    		if(!subscribeBtn.classList.contains('disabledBtn')) submitEmail();
		};
		const setFocus = () => {
			let linksInWindow = [];
			for(let i = 0; i < pageLinks.length; i++){
				if(isInViewPort(pageLinks[i]))
					linksInWindow.push(pageLinks[i]);
			}
			
			setTimeout(() => {
				if(linksInWindow.length > 0)
					linksInWindow[0].focus();
				else pageLinks[0].focus(); // not sure a better way to do this other than go to first link in the page if no links are in the viewport
			}, 200);
		};
		const isInViewPort = link => {
			let docViewTop = window.scrollY + 60, 
			docViewBottom = docViewTop + window.innerHeight,
			elemTop = link.offsetTop,
			elemBottom = elemTop + link.offsetHeight; 
			
			return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom));
		};
	    	const submitEmail = () => {
	        	let email = emailInput.value;
	        	
	        	//validate email field
	        	if (SubscribeForm.ValidateEmail()) {
	        		let headerToken = document.getElementById("articleSubscriptionForm").getElementsByTagName('input')[0].getAttribute("value");

					let data = {EmailPrefs:"Amplify Subscription:true", EmailAddress: email, UserId: -1};

	            		// let data = {emailPrefs:"Amplify Subscription:true", emailAddress: email, userID: "-1"};
	            			            		
	            		disableBtn();
	            		emailInput.disabled = true;
	            		submitLoading.classList.remove('hide');
				
				fetch('/Esp/SavePublicUserSubscriptions', { 
		        		method: 'POST', 
		        		credentials: 'same-origin',
		        		body: JSON.stringify(data), 
		        		headers: { 
		        			'Content-Type': 'application/json', 
		        			'X-Requested-With': 'fetch',
		        			"RequestVerificationToken": headerToken
		        		}
				}).then(function(response){
					return  (response.ok) ? response.json() : []; // response.text() returns a promise
				}).then(function(response){
					submitLoading.classList.add('hide');
					
	        			document.querySelector('.subscribeForm').classList.add('hide');
	       			infoText.insertAdjacentHTML('afterend', '<p class="text18 padding20 textCenter textBlue" role="status">Thank you for successfully signing up to receive future articles.</p>');
				}).catch(function(response){
					submitLoading.classList.add('hide');
	                		requestFailed();
	            		});
	        	}
		};
		const requestFailed = () =>{
    			subscribeBtn.classList.remove('disabledBtn');
    			subscribeBtn.classList.add('whiteLink');
    			subscribeBtn.removeAttribute('disabled');
	        	emailInput.removeAttribute('disabled');
	        	let errorMessage = 
				'<div class="ErrorMsgPanel text15 validation-summary-errors textDkRed" id="ErrorBox" aria-live="assertive">' +
					'<p class="paddingTop15 paddingBtm15 textSemiBold marginLeft10 validationHeading textDkRed" id="ErrorTitle">Uh-oh! There was an issue with your request. Please refresh and try again.</p>' +
				'</div>';
				
	        	infoText.insertAdjacentHTML('afterend', errorMessage);
		};
    		return{
    			Init: init
    		};
    	})(),
    	
    	SubscribeForm = (function(){
    		const validateEmail = () => {
	    		let email = emailInput.value.trim(),
	        	pattern = emailInput.getAttribute('data-val-regex-pattern'),
	        	matches = email.match(pattern);
	        		        	
	        	removeErrors(emailInput);
	        	
	        	if (matches != null) return true;
			
			addErrors(emailInput);
	        	return false;
	    	};
	    	const removeErrors = (el) =>{
	    		if(document.querySelector(".invalidEmailLink")) document.querySelector(".invalidEmailLink").removeEventListener("click", focusOnError);
	    		if(document.querySelector(".ErrorMsgPanel")) document.querySelector(".ErrorMsgPanel").parentNode.removeChild(document.querySelector(".ErrorMsgPanel"));

			if(el.classList.contains("input-validation-error")) {
	        		el.classList.remove("input-validation-error");
	        		el.removeAttribute("aria-invalid");
	        	}
	    	};
	    	const addErrors = (el) =>{
	    		let errorMsg = 
				'<div class="ErrorMsgPanel text15 validation-summary-errors textDkRed" id="ErrorBox" aria-live="assertive">' +
					'<p class="paddingTop15 textBold marginLeft10 validationHeading textDkRed" id="ErrorTitle">Please correct the following errors and resubmit:</p>' +
					'<ul class="paddingLeft20 marginLeft20 textDkRed text14">' +
						'<li><a href="#" class="invalidEmailLink">Please enter a valid Email</a></li>' +
					'</ul>' +
				'</div>';
			document.getElementById('infoTextEmail').insertAdjacentHTML('afterend', errorMsg);
	        	document.querySelector(".ErrorMsgPanel").querySelector("ul").querySelector("a").focus();
	        	document.querySelector(".invalidEmailLink").addEventListener("click", focusOnError);
	        	el.classList.add("input-validation-error");
	        	el.setAttribute("aria-invalid", "true");
	    	};
	    	const focusOnError = (e) =>{
	    		e.preventDefault();
	    		if(emailInput !== "") emailInput.focus();
	    		return false;
	    	};
	    	
    		return{
    			ValidateEmail: validateEmail
    		};
    	})();

    	return{
        	Init: init
    	};
};

(async () =>{
	const articleSubscribe = new marketingPage();
	articleSubscribe.Init();
})()